import { append_to_dom, handle_favorites, is_favorited } from "./functions";
var delete_id;
var can_favorite = true;

export function set_can_favorite(result) {
  can_favorite = result;
}

var authors_ids = [];

export { authors_ids };

jQuery(document).ready(function ($) {
  if (
    window.location.pathname.includes("/recipe/") &&
    !window.location.pathname.endsWith("recipe/")
  ) {
    if ($("#authors_ids").data("authors-ids")) {
      authors_ids = $("#authors_ids").data("authors-ids") + "";
      authors_ids = authors_ids.split("__");
    }
  }
  if (
    ( window.location.pathname.includes("/recipe/") && !window.location.pathname.endsWith("recipe/") ) 
    ||
     ( window.location.pathname.includes("/article/") && !window.location.pathname.endsWith("article/") ) 
  ) {
  if (JSON.parse(localStorage.getItem("login_result"))?.is_logged_in) {
    is_favorited();
  }

  $("#onLikeClick").on("click", function () {
    if (JSON.parse(localStorage.getItem("login_result"))?.is_logged_in) {
      localStorage.removeItem("favorite_item");
      if (can_favorite) {
        set_can_favorite(false);
        handle_favorites(null, false);
      }
    } else {
      localStorage.setItem(
        "favorite_item",
        $("#onLikeClick").attr("data-id")
      );
      append_to_dom("popup-login-open", "popup-login", null);
    }
  });
}

// handle_favorites(post_id, true)

$(".my-favorite-recipes .article  .article__overlay a").on(
  "click",
  function () {
    delete_id = $(this)[0].attributes["data-delete-id"].value;
    append_to_dom(
      "popup-remove-from-favorites-open",
      "delete_fav_recipe_confirm",
      null
    );
    // $("#delete_fav_recipe_confirm").addClass("is-active");
  }
);

$(document).on(
  "click",
  "#delete_fav_recipe_confirm #recipe_delete_confirm",
  function () {
    $("#delete_fav_recipe_confirm #recipe_delete_confirm").addClass(
      "button--loading"
    );
    handle_favorites(delete_id, true);
  }
);

// .my-favorite-recipes .shell .section__body .section__inner .articles .grid .grid__col .article .article__media.article__image.article__overlay a

$(document).on(
  "click",
  "#delete_fav_recipe_confirm #recipe_delete_cancel",
  function () {
    $("#delete_fav_recipe_confirm").remove();
  }
);

if (localStorage.getItem("login_result")) {
  if (JSON.parse(localStorage.getItem("login_result")).is_logged_in) {
    if (localStorage.getItem("user_info")) {
      if (JSON.parse(localStorage.getItem("user_info")).favorites) {
        if (
          JSON.parse(localStorage.getItem("user_info")).favorites.length !== 0
        ) {
          $("#my_faved_recipes_count").css("display", "block");
          $("#my_faved_recipes_count").text(
            Object.values(
              JSON.parse(localStorage.getItem("user_info")).favorites
            ).length
          );
        }
      }
    }
  }
}
});
